import {conf} from "../../config";

export function getUrlParam(name: string, url?: string) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

export function getCountryFromUrl() {
  let url = window.location.href;
  let fragments = url.substr(url.indexOf('newyorker.de/') + 13).split('/'); // split URL path in segments
  let cc = conf.defaultLocale;
  if (fragments && fragments.length > 0) {
    cc = fragments[0];
    if (!cc || cc === '' || cc.startsWith("host") || cc.length > 2) {
      cc = conf.defaultLocale;
    }
  }
  return cc;
}

export function addCountryToRelativeUrl(url: string) {
  const cc = getCountryFromUrl();
  if (!url.startsWith('/')) {
    return url;
  }

  if (cc === conf.defaultLocale) {
    return url;
  }

  return `/${cc}${url}`
}
